import { ITypographyProps } from '../../../BaseComponents/Typography/EDTypography';
import { ValueType } from '../../../Utils/Formatters/FormatterTypes';
import {
  IClientAttributeModel,
  IClientBusinessModel,
} from '../../../Types/ClientModelTypes';
import { findFormatter } from '../../../Utils/Formatters/FindFormatter';
import DisplayText from '../DisplayText/DisplayText';
import { findDisplayComp } from '../../../Features/Delsystem/_Common/Const/BusinessConfigs';

interface IProps extends ITypographyProps {
  value: ValueType;
  attributeModel: IClientAttributeModel;
  collection: IClientBusinessModel;
  testId?: string;
  forceText?: boolean;
  masked?: boolean;
}

/**
 * Komponent för att visa korrekt formaterad text för ett attribut mha formatter.
 */
const AttributeDisplayText = (props: IProps) => {
  const { attributeModel, ...rest } = props;
  const formatter = findFormatter(
    attributeModel.Formatter,
    attributeModel.DataType
  );
  const displayComp = props.forceText
    ? undefined
    : findDisplayComp(
        props.collection.CollectionName,
        attributeModel.AttributeName
      );
  return (
    <DisplayText
      {...rest}
      displayer={formatter.displayer}
      params={attributeModel.FormatterDisplayParams}
      displayComp={displayComp}
      noValueChar="—"
    />
  );
};

export default AttributeDisplayText;
